export const SEND_NOTIFICATIONS_REQUEST = 'SEND_NOTIFICATIONS_REQUEST';
export const sendNotifications = (fulfillmentPlanIds) => ({
  type: SEND_NOTIFICATIONS_REQUEST,
  fulfillmentPlanIds,
});

export const SEND_NOTIFICATIONS_SUCCESS = 'SEND_NOTIFICATIONS_SUCCESS';
export const sendNotificationsSuccess = (response) => ({
  type: SEND_NOTIFICATIONS_SUCCESS,
  response,
});

export const SEND_NOTIFICATIONS_FAILURE = 'SEND_NOTIFICATIONS_FAILURE';
export const sendNotificationsFailure = (error) => ({
  type: SEND_NOTIFICATIONS_FAILURE,
  error,
});

export const RETRY_NOTIFICATIONS_REQUEST = 'RETRY_NOTIFICATIONS_REQUEST';
export const retryNotifications = (fulfillmentPlanIds) => ({
  type: RETRY_NOTIFICATIONS_REQUEST,
  fulfillmentPlanIds,
});
